import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const CategoryFilter = ({ selectedCategories, onCategoryChange }) => {
  const categories = [
    {
      id: 'engine',
      label: 'Moteur / Engine',
      labelEn: 'Engine Parts',
      labelFr: 'Pièces Moteur',
      icon: 'Cog',
      subcategories: [
        { id: 'engine_block', label: 'Bloc moteur / Engine block' },
        { id: 'pistons', label: 'Pistons' },
        { id: 'valves', label: 'Soupapes / Valves' },
        { id: 'gaskets', label: 'Joints / Gaskets' },
        { id: 'filters', label: 'Filtres / Filters' }
      ]
    },
    {
      id: 'brake',
      label: 'Freinage / Brake',
      labelEn: 'Brake System',
      labelFr: 'Système de Freinage',
      icon: 'Disc',
      subcategories: [
        { id: 'brake_pads', label: 'Plaquettes / Brake pads' },
        { id: 'brake_discs', label: 'Disques / Brake discs' },
        { id: 'brake_fluid', label: 'Liquide de frein / Brake fluid' },
        { id: 'brake_lines', label: 'Durites / Brake lines' }
      ]
    },
    {
      id: 'suspension',
      label: 'Suspension',
      labelEn: 'Suspension',
      labelFr: 'Suspension',
      icon: 'Zap',
      subcategories: [
        { id: 'shock_absorbers', label: 'Amortisseurs / Shock absorbers' },
        { id: 'springs', label: 'Ressorts / Springs' },
        { id: 'struts', label: 'Jambes de force / Struts' },
        { id: 'bushings', label: 'Silent-blocs / Bushings' }
      ]
    },
    {
      id: 'electrical',
      label: 'Électrique / Electrical',
      labelEn: 'Electrical',
      labelFr: 'Électrique',
      icon: 'Zap',
      subcategories: [
        { id: 'battery', label: 'Batterie / Battery' },
        { id: 'alternator', label: 'Alternateur / Alternator' },
        { id: 'starter', label: 'Démarreur / Starter' },
        { id: 'lights', label: 'Éclairage / Lights' }
      ]
    },
    {
      id: 'body',
      label: 'Carrosserie / Body',
      labelEn: 'Body Parts',
      labelFr: 'Carrosserie',
      icon: 'Car',
      subcategories: [
        { id: 'doors', label: 'Portes / Doors' },
        { id: 'bumpers', label: 'Pare-chocs / Bumpers' },
        { id: 'mirrors', label: 'Rétroviseurs / Mirrors' },
        { id: 'windows', label: 'Vitres / Windows' }
      ]
    },
    {
      id: 'tires',
      label: 'Pneus / Tires',
      labelEn: 'Tires & Wheels',
      labelFr: 'Pneus et Jantes',
      icon: 'Circle',
      subcategories: [
        { id: 'tires_new', label: 'Pneus neufs / New tires' },
        { id: 'tires_used', label: 'Pneus occasion / Used tires' },
        { id: 'wheels', label: 'Jantes / Wheels' },
        { id: 'tire_tools', label: 'Outils pneus / Tire tools' }
      ]
    }
  ];

  const handleCategoryToggle = (categoryId) => {
    const newCategories = selectedCategories?.includes(categoryId)
      ? selectedCategories?.filter(id => id !== categoryId)
      : [...selectedCategories, categoryId];
    onCategoryChange(newCategories);
  };

  const handleSubcategoryToggle = (subcategoryId) => {
    const newCategories = selectedCategories?.includes(subcategoryId)
      ? selectedCategories?.filter(id => id !== subcategoryId)
      : [...selectedCategories, subcategoryId];
    onCategoryChange(newCategories);
  };

  return (
    <div className="space-y-4">
      {categories?.map((category) => (
        <div key={category?.id} className="border border-border rounded-lg p-3">
          <div className="flex items-center space-x-3 mb-3">
            <Checkbox
              checked={selectedCategories?.includes(category?.id)}
              onChange={() => handleCategoryToggle(category?.id)}
            />
            <Icon name={category?.icon} size={18} className="text-primary" />
            <span className="font-medium text-foreground">{category?.label}</span>
          </div>
          
          {selectedCategories?.includes(category?.id) && (
            <div className="ml-6 space-y-2 border-l-2 border-primary/20 pl-4">
              {category?.subcategories?.map((subcategory) => (
                <div key={subcategory?.id} className="flex items-center space-x-2">
                  <Checkbox
                    checked={selectedCategories?.includes(subcategory?.id)}
                    onChange={() => handleSubcategoryToggle(subcategory?.id)}
                    size="sm"
                  />
                  <span className="text-sm text-muted-foreground">{subcategory?.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CategoryFilter;